import React, { useState } from "react";
import { motion } from "framer-motion";
import { REVEAL } from "@/lib/motion";

const BEFORE = [
  "Leads in five places.",
  "Replies hours later.",
  "Follow-up depends on who remembers.",
  "Data copied by hand.",
];

const AFTER = [
  "One connected workflow.",
  "Every lead answered in about a minute.",
  "Follow-up runs on its own.",
  "CRM always up to date.",
];

const TILTS = ["-rotate-2", "rotate-1", "-rotate-1", "rotate-2"];

const BeforePanel = () => (
  <div className="group bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/10 p-7 sm:p-9" data-testid="before-panel">
    <p className="text-xs uppercase tracking-[0.18em] font-semibold text-[#4A463F]">Before</p>
    <div className="mt-7 space-y-4">
      {BEFORE.map((b, i) => (
        <div
          key={b}
          className={`${TILTS[i]} group-hover:rotate-0 transition-transform duration-500 bg-[#F4E9D8] border border-[#1F1F1C]/15 rounded-xl px-5 py-4 text-sm font-semibold text-[#1F1F1C]`}
          data-testid={`before-item-${i + 1}`}
        >
          {b}
        </div>
      ))}
    </div>
  </div>
);

const AfterPanel = () => (
  <div className="bg-[#3D472D] rounded-2xl border border-[#3D472D] p-7 sm:p-9" data-testid="after-panel">
    <p className="text-xs uppercase tracking-[0.18em] font-semibold text-[#C8703A]">After Raki</p>
    <div className="mt-7 space-y-4">
      {AFTER.map((a, i) => (
        <div
          key={a}
          className="bg-[#55633F]/50 border border-[#F4E9D8]/25 rounded-xl px-5 py-4 text-sm font-semibold text-[#F4E9D8]"
          data-testid={`after-item-${i + 1}`}
        >
          {a}
        </div>
      ))}
    </div>
  </div>
);

export const HomeBeforeAfter = () => {
  const [showAfter, setShowAfter] = useState(false);

  return (
    <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="home-before-after">
      <div className="max-w-5xl mx-auto">
        <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">
          Before and after.
        </motion.h2>

        <div className="mt-8 md:hidden flex rounded-2xl border border-[#1F1F1C]/20 p-1" data-testid="before-after-toggle">
          <button
            onClick={() => setShowAfter(false)}
            className={`flex-1 rounded-xl py-2.5 text-sm font-semibold ${!showAfter ? "bg-[#3D472D] text-[#F4E9D8]" : "text-[#4A463F]"}`}
            data-testid="toggle-before"
          >
            Before
          </button>
          <button
            onClick={() => setShowAfter(true)}
            className={`flex-1 rounded-xl py-2.5 text-sm font-semibold ${showAfter ? "bg-[#3D472D] text-[#F4E9D8]" : "text-[#4A463F]"}`}
            data-testid="toggle-after"
          >
            After Raki
          </button>
        </div>

        <div className="mt-6 md:mt-10 md:grid md:grid-cols-2 md:gap-5">
          <div className={showAfter ? "hidden md:block" : "block"}>
            <BeforePanel />
          </div>
          <div className={showAfter ? "block" : "hidden md:block"}>
            <AfterPanel />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBeforeAfter;
